<template>
  <nav class="navbar navbar-expand-lg ">
    <div class="container-fluid">
      <div class="navbar-minimize">
        <button class="btn btn-outline btn-fill btn-round btn-icon d-none d-lg-block" @click="minimizeSidebar">
          <i :class="$sidebar.isMinimized ? 'fa fa-ellipsis-v' : 'fa fa-navicon'"></i>
        </button>
      </div> 
      <div class="col-auto"> <h3>SISTEMA VENTANA UNICA</h3>  </div>
      <button @click="cerrarSession" class="btn btn-danger btn-sm">Cerrar sesión</button> 
    </div>
  </nav>
</template>
<script>
import Router from './../../routes'
//import store from './../../store'
import Swal from "sweetalert2"

  export default {
    computed: {
      routeName () {
        const {name} = this.$route

        return this.capitalizeFirstLetter(name)
      },
    },
    data () {
      return {
        activeNotifications: false
      }
    },
    mounted(){
    },
    methods: {
        async cerrarSession()
        {

            const { value } = await Swal({
                title: ' ',
                text: `¿Esta seguro que quiere salir del sistema?`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'btn btn-success btn-fill',
                cancelButtonClass: 'btn btn-danger btn-fill',
                confirmButtonText: '¡Sí, cerrar sesión!',
                cancelButtonText: 'Cancelar',
                buttonsStyling: false
              }) 
              
            if(!value) return
            
            Router.push({path: '/logout'})

        },
        capitalizeFirstLetter (string) {
            return string.charAt(0).toUpperCase() + string.slice(1)
        },
        toggleNotificationDropDown () {
            this.activeNotifications = !this.activeNotifications
        },
        closeDropDown () {
            this.activeNotifications = false
        },
        toggleSidebar () {
            this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
        },
        hideSidebar () {
            this.$sidebar.displaySidebar(false)
        },
        minimizeSidebar () {
            this.$sidebar.toggleMinimize()
        }
    }
  }

</script>
<style scoped>


</style>
